import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import { FolderNameWithTooltipProps } from './folderTypes';

const FolderNameWithTooltip = ({ name, isSelected, theme }: FolderNameWithTooltipProps) => {
  const textRef = React.useRef<HTMLElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = React.useState(false);

  React.useEffect(() => {
    const checkForEllipsis = () => {
      if (textRef.current) {
        setIsEllipsisActive(textRef.current.offsetWidth < textRef.current.scrollWidth);
      }
    };

    checkForEllipsis();
    // Check again if window resizes
    window.addEventListener('resize', checkForEllipsis);
    return () => window.removeEventListener('resize', checkForEllipsis);
  }, [name]);

  const textComponent = (
    <Typography
      variant="body2"
      ref={textRef}
      sx={{
        fontWeight: isSelected ? 500 : 400,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        flex: 1,
      }}
    >
      {name}
    </Typography>
  );

  // Only add tooltip if text is actually truncated
  if (isEllipsisActive) {
    return (
      <Tooltip
        title={name}
        arrow
        placement="top-start"
        enterDelay={500}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              boxShadow: 2,
              fontSize: '0.75rem',
              p: 1,
              border: `1px solid ${theme.palette.divider}`,
              maxWidth: 'none',
            },
          },
        }}
      >
        {textComponent}
      </Tooltip>
    );
  }

  return textComponent;
};

export default React.memo(FolderNameWithTooltip);
